import { render } from "./sLayout.vue?vue&type=template&id=91bb4828"
import script from "./sLayout.vue?vue&type=script&lang=js"
export * from "./sLayout.vue?vue&type=script&lang=js"

import "./sLayout.vue?vue&type=style&index=0&id=91bb4828&lang=less"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__